
import { toaster, ToasterContainer, PLACEMENT, ToastProps } from "baseui/toast";

export const rsToaster = {
  info: (msg, payload: ToastProps = {}) => toaster.info(msg, payload),
  success: (msg, payload: ToastProps = {}) => toaster.positive(msg, payload),
  warn: (msg, payload: ToastProps = {}) => toaster.warning(msg, payload),
  error: (msg, payload: ToastProps = {}) => toaster.negative(msg, payload),
};
